// Builds a rich share message for a program/event including when, where and who leads it.
import { todRange } from './datetime';

const tzLabel = (tz) => {
  if (!tz) return '';
  try {
    const part = new Intl.DateTimeFormat('en-US', { timeZone: tz, timeZoneName: 'short' })
      .formatToParts(new Date()).find((x) => x.type === 'timeZoneName');
    return part ? part.value : tz;
  } catch { return tz; }
};

const fmtWhen = (p) => {
  if (p.type === 'class') {
    const days = p.recurrence?.days_of_week?.length ? ` (${p.recurrence.days_of_week.join(', ')})` : '';
    return p.time_of_day ? `🗓 ${todRange(p.time_of_day, p.duration_minutes)}${days}` : '';
  }
  if (!p.start_datetime) return '';
  try {
    const dOpts = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };
    const tOpts = { hour: 'numeric', minute: '2-digit' };
    const s = new Date(p.start_datetime);
    const sd = s.toLocaleDateString(undefined, dOpts);
    const st = s.toLocaleTimeString(undefined, tOpts);
    const tz = p.timezone ? ` ${tzLabel(p.timezone)}` : '';
    if (!p.end_datetime) return `🗓 ${sd} at ${st}${tz}`;
    const e = new Date(p.end_datetime);
    const et = e.toLocaleTimeString(undefined, tOpts);
    if (s.toDateString() === e.toDateString()) return `🗓 ${sd} · ${st} – ${et}${tz}`;
    const ed = e.toLocaleDateString(undefined, dOpts);
    return `🗓 ${sd}, ${st} → ${ed}, ${et}${tz}`;
  } catch { return ''; }
};

export const programShareText = (p) => {
  if (!p) return '';
  const lines = [`Join "${p.title}" at Osho Universal`];
  const when = fmtWhen(p);
  if (when) lines.push(when);
  const where = p.mode === 'online' ? '📍 Online' : (p.location ? `📍 ${p.location}` : '');
  if (where) lines.push(where);
  const led = (p.facilitator_names || []).filter(Boolean).join(', ');
  if (led) lines.push(`🧘 Led by ${led}`);
  return lines.join('\n');
};
